<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-6">
                <b-card>
                    <div slot="header">
                        <i :class="[isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']"></i><strong> Bedrijf</strong>
                        <small>
                            <span v-if="isEditing">wijzigen</span>
                            <span v-else>toevoegen</span>
                        </small>
                    </div>
                    <form @submit.prevent="saveItem">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="col-form-label" for="naam">Naam <sup>*</sup></label>
                                <input type="text" v-model="model.naam" id="naam" name="naam" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('naam') }" />
                                <span class="small text-danger" v-show="errors.has('naam')">Naam is verplicht</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="col-form-label" for="straatNr">Straat en nummer</label>
                                <input type="text" v-model="model.straatNr" id="straatNr" name="straatNr" class="form-control" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="col-form-label" for="postcode">Postcode</label>
                                <input type="text" v-model="model.postcode" id="postcode" name="postcode" class="form-control" />
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <div class="form-group">
                                <label class="col-form-label" for="plaats">Plaats</label>
                                <input type="text" v-model="model.plaats" id="plaats" name="plaats" class="form-control" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="col-form-label" for="tel">Telefoonnummer</label>
                                <input type="text" v-model="model.tel" id="tel" name="tel" class="form-control" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="col-form-label" for="weerstation">Weerstation <sup>*</sup></label>
                                <select type="text" v-model="model.weerstation_id" id="weerstation" name="weerstation" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('weerstation') }" >
                                    <template v-for="weerstation in weerstations">
                                        <option :value="weerstation.id" :selected="weerstation.id == (model.weerstation && model.weerstation_id)">{{weerstation.plaats}}</option>
                                    </template>
                                </select>
                                <span class="small text-danger" v-show="errors.has('weerstation')">Kies een weerstation</span>
                            </div>
                        </div>
                    </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label class="col-form-label" for="voorspellingsplaats">Weersvoorspelling plaats <sup>*</sup></label>
                                    <select type="text" v-model="model.voorspellingsplaats_id" id="voorspellingsplaats" name="voorspellingsplaats" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('voorspellingsplaats') }" >
                                        <template v-for="voorspellingsplaats in voorspellingsplaatsen">
                                            <option :value="voorspellingsplaats.id" :selected="voorspellingsplaats.id == (model.voorspellingsplaats && model.voorspellingsplaats_id)">{{voorspellingsplaats.plaats}}</option>
                                        </template>
                                    </select>
                                    <span class="small text-danger" v-show="errors.has('voorspellingsplaats')">Kies een plaats</span>
                                </div>
                            </div>
                        </div>
                    <div slot="footer">
                        <b-button type="submit" variant="primary">
                            <span>Opslaan</span>
                        </b-button>
                        <b-button type="button" @click="back" variant="secondary"> Annuleren</b-button>
                    </div>
                    </form>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Form',
        props: ['model', 'weerstations', 'voorspellingsplaatsen', 'isEditing'],
        methods: {
            saveItem () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$emit('save-item', this.model);
                    }
                });
            },
            back () {
                this.$router.go(-1);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/bedrijf/Form.vue